export const getBudgetFormStyles = () => ({
  formContainer: {
    maxWidth: 680,
    minWidth: 300,
    flex: '1',
    '& .bid-strategy-dropdown': {
      '& .ms-Dropdown': {
        maxWidth: 312,
      },
    },
  },

  budgetTitle: {
    fontSize: '18px',
    display: 'inline',
  },
});
